// Filtering for searchable dropdowns (components/SearchableSelect.tsx): case- and accent-insensitive,
// every typed word must appear in the label ("allg orts" finds "AOK – Allgemeine Ortskrankenkasse").
// Best matches first: label starts with the query, then a word starts with it, then anywhere.

export interface SearchOption { value: string; label: string }

export function normalizeSearch(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss').toLowerCase().trim()
}

export function filterOptions<T extends SearchOption>(options: T[], query: string): T[] {
  const q = normalizeSearch(query)
  if (!q) return options
  const words = q.split(/\s+/).filter(Boolean)
  const scored: { option: T; score: number; index: number }[] = []
  options.forEach((option, index) => {
    const label = normalizeSearch(option.label)
    const haystack = `${label} ${normalizeSearch(option.value)}`
    if (!words.every(w => haystack.includes(w))) return
    const score = label.startsWith(q) ? 0 : label.split(/[\s\-–/(),.]+/).some(part => part.startsWith(words[0])) ? 1 : 2
    scored.push({ option, score, index })
  })
  return scored.sort((a, b) => a.score - b.score || a.index - b.index).map(s => s.option)
}
